import { render, staticRenderFns } from "./FormGridBox.vue?vue&type=template&id=1427f236"
import script from "./FormGridBox.vue?vue&type=script&lang=js"
export * from "./FormGridBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports